import React from "react";

import { Flex, Icon, SkeletonWrapper } from "components";

interface ReviewPageTitleProps {
  title: string;
  iconName?: string;
  isLoading?: boolean;
}

export const ReviewPageTitle = ({ iconName, title, isLoading }: ReviewPageTitleProps) => (
  <Flex className="padding-125 margin-bottom-100" align="center" justify="space-between">
    <Flex gap={12}>
      <SkeletonWrapper className="margin-0 skeleton-rectangular" width="100%" height="2rem" type="block" isLoading={isLoading}>
        {iconName && <Icon iconName={iconName} />}
        <h3>{title}</h3>
      </SkeletonWrapper>
    </Flex>
  </Flex>
);
